import React from 'react';
import AQIMap from './AQIMap';
import { ThemeProvider } from './context/ThemeContext';
import 'leaflet/dist/leaflet.css';
import './styles/map.css';
import './styles/components.css';

// Main Map Component Wrapper
const MapWrapper = () => (
    <ThemeProvider>
        <div style={{ width: '100%', minHeight: '100vh', overflow: 'auto' }}>
            <AQIMap />
        </div>
    </ThemeProvider>
);

export default MapWrapper;

// Named exports for sub-components (if needed elsewhere)
export { default as AQIMap } from './AQIMap';
export { default as AQIMarker } from './AQIMarker';
export { default as AQILegend } from './AQILegend';
export { default as MarkerCluster } from './MarkerCluster';
export { default as PerformanceZones } from './PerformanceZones';
export { default as PolesTable } from './PolesTable';

// Export utilities
export * from './utils/aqiUtils';
export * from './config/constants';
export * from './data/staticData';

